import React, { Component } from 'react';
import { connect } from 'react-redux';

import List from './Activities/List';
import Map from './Activities/Map';
import NoResults from './Activities/NoResults';

class ActivityList extends Component
{
    render() {
        const { onTabClick, displayType, results, listCurrentPage, setListCurrentPage } = this.props;
        const block = (displayType === 'list' ? <List listCurrentPage={listCurrentPage} setListCurrentPage={setListCurrentPage} /> : <Map />);
        return (
            <div className={['main-content', `${displayType}-view`].join(' ')}>
                <div className="view-toggle-container">
                    <div className="view-toggle-tabs">
                        <button className={['view-tab-button', displayType === 'list' && 'active'].join(' ')} onClick={() => onTabClick('list')}>
                            <i className="icon icon-list"></i>
                            <span>List view</span>
                        </button>
                        <button className={['view-tab-button', displayType === 'map' && 'active'].join(' ')} onClick={() => onTabClick('map')}>
                            <i className="icon icon-location-mark"></i>
                            <span>Map view</span>
                        </button>
                    </div>
                </div>
                {results.length !== 0 ? block : <NoResults />}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    results: state.searchActivities,
    displayType: state.displayType,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);
